import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TOURNAMENT_PAGE_LIKE = 'TOURNAMENT_PAGE_LIKE'
export const TOURNAMENT_PAGE_LIKE_ERROR = 'TOURNAMENT_PAGE_LIKE_ERROR'
export const TOURNAMENT_PAGE_LIKE_FULFILLED = 'TOURNAMENT_PAGE_LIKE_FULFILLED'
export const TOURNAMENT_PAGE_LIKE_CANCELED = 'TOURNAMENT_PAGE_LIKE_CANCELED'

export const tournamentPageLike = (tournamentId, like) => ({
  payload: {
    like,
    tournamentId,
  },
  type: TOURNAMENT_PAGE_LIKE,
})

export const tournamentPageLikeFulfilled = (payload) => ({
  payload,
  type: TOURNAMENT_PAGE_LIKE_FULFILLED,
})

export const tournamentPageLikeCanceled = () => ({
  payload: null,
  type: TOURNAMENT_PAGE_LIKE_CANCELED,
})

export const tournamentPageLikeError = (payload) => ({
  payload,
  type: TOURNAMENT_PAGE_LIKE_ERROR,
})

export const tournamentPageLikeEpic = (action$) =>
  action$.pipe(
    ofType(TOURNAMENT_PAGE_LIKE),
    mergeMap((action) =>
      epicServerRequest(
        action.payload.like ? 'post' : 'delete',
        `${APP.api_url}/sports/tournament/${action.payload.tournamentId}/${action.payload.like ? 'like' : 'unfollow'}`,
        action,
      ).pipe(
        map(epicResponseHandler(tournamentPageLikeFulfilled, action)),
        takeUntil(action$.pipe(ofType(TOURNAMENT_PAGE_LIKE_CANCELED))),
        catchError(epicErrorHandler(tournamentPageLikeError, action)),
      ),
    ),
  )
